import { FieldHandle, FormTheme } from '@kanda-libs/ks-component-ts';

import useFinanceCalculatorAPRSelect from './useFinanceCalculatorAPRSelect';

export interface APRProps {
  apr: string;
}

const APR: React.FunctionComponent<APRProps> = function ({ apr }) {
  const { onClick, isSelected } = useFinanceCalculatorAPRSelect(apr);
  return (
    <div className="flex flex-row gap-x-2 px-2 pt-2 pb-1 border border-neutral-300 rounded">
      <div className="my-auto">
        <FormTheme variant="clean">
          <FieldHandle.Checkbox
            id={apr}
            onClick={onClick}
            checked={isSelected}
            onChange={() => {}}
          />
        </FormTheme>
      </div>
      <p className="text-14-22-em">{apr}</p>
    </div>
  );
};

export default APR;
